// extracted by mini-css-extract-plugin
export default {"thumb":"cawxI1","iconThumb":"oau6gN","disabled":"r0UHzT","iconWrap":"Sy1D8S","thumbUp":"_NjxPe","thumbDown":"gCHOJh","active":"qpM3Ru","count":"Tp9T04"};